import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, Dialog, DialogActions, DialogContentText, Slide, Typography, useMediaQuery } from '@mui/material';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread({
    direction: "up",
    ref: ref
  }, props));
});
export var unsavedMessage = 'Are you sure you want to leave? Your unsaved changes will be discarded.';
export var UnsavedChangesModal = function UnsavedChangesModal(_ref) {
  var open = _ref.open,
      onCancel = _ref.onCancel,
      onContinue = _ref.onContinue;
  var isSmallMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Dialog, {
    maxWidth: "sm",
    open: open,
    TransitionComponent: Transition,
    "aria-describedby": "unsaved-changes",
    "data-element": "Dialog",
    "data-component": "UnsavedChangesModal",
    "data-source-file": "unsaved-changes-modal.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: {
        m: 2
      },
      variant: "h3",
      "data-element": "Typography",
      "data-component": "UnsavedChangesModal",
      "data-source-file": "unsaved-changes-modal.tsx",
      children: t('Unsaved Changes')
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        mx: 2,
        my: 1
      },
      "data-element": "Box",
      "data-source-file": "unsaved-changes-modal.tsx",
      children: /*#__PURE__*/_jsx(DialogContentText, {
        id: "unsaved-changes",
        "data-element": "DialogContentText",
        "data-source-file": "unsaved-changes-modal.tsx",
        children: t(unsavedMessage)
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      sx: {
        flexDirection: isSmallMobile ? 'column' : 'row'
      },
      "data-element": "DialogActions",
      "data-source-file": "unsaved-changes-modal.tsx",
      children: [/*#__PURE__*/_jsx(Button, {
        sx: {
          mx: 2,
          my: 1
        },
        onClick: onCancel,
        "data-element": "Button",
        "data-source-file": "unsaved-changes-modal.tsx",
        children: t('Take me back')
      }), /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        sx: {
          mx: 2,
          my: 1
        },
        onClick: onContinue,
        "data-element": "Button",
        "data-source-file": "unsaved-changes-modal.tsx",
        children: t('Discard changes')
      })]
    })]
  });
};